import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'appManualProvider',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  editURL: '',
  emptyMessage: "You don't have tokens, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'token',
      label: 'Token',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Token string',
      default: '',
      canEdit: false,
      canCreate: true,
      canOrder: false,
      canFilter: true,
    },
    {
      attributeName: 'created_at',
      label: 'Created at',
      type: FormInputTypes.DATE_TIME,
      helpText: 'The date when the token was generated.',
      default: '',
      canEdit: false,
      canCreate: true,
      canOrder: false,
      canFilter: true,
    },
    {
      attributeName: 'trackingStatus',
      label: 'Purchase Status',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Purchase token status (created, pending, adquired, not completed or canceled).',
      default: '',
      canEdit: false,
      canCreate: true,
      canOrder: false,
      canFilter: true,
    },
    {
      attributeName: 'trackingId',
      label: 'Tracking ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The tracking Id sending to the purchase provider.',
      default: '',
      canEdit: false,
      canCreate: true,
      canOrder: false,
      canFilter: true,
    },
    {
      attributeName: 'operationId',
      label: 'Operation ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The operation Id registered from the purchase provider when the end user completes a purchase.',
      default: '',
      canEdit: false,
      canCreate: true,
      canOrder: false,
      canFilter: true,
    },
    {
      attributeName: 'operationDate',
      label: 'Operation Date',
      type: FormInputTypes.DATE_TIME,
      helpText: 'The operation date registered from the purchase provider when the end user completes a purchase.',
      default: '',
      canEdit: false,
      canCreate: true,
      canOrder: false,
      canFilter: true,
    },
    {
      attributeName: 'used',
      label: 'Transactions',
      width: '12rem',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      helpText: 'Number of times that the token was used',
      default: '',
      canEdit: false,
      canCreate: false,
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'failUsed',
      label: 'Fail Transactions',
      width: '14rem',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      helpText: 'Number of times that the token was used as a fail',
      default: '',
      canEdit: false,
      canCreate: false,
      canOrder: false,
      canFilter: false,
    },
    {
      attributeName: 'link',
      label: 'Kibana Link',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      width: '10rem',
      helpText: 'Kibana external link with the devices associated with the token attribute of this row.',
    },
    {
      attributeName: 'revokeToken',
      label: 'Revoke',
      type: FormInputTypes.BUTTON,
      helpText: 'To revoke all transactions of this token',
      width: '7rem',
    },
  ],
};
